import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import { motion, Variants } from "framer-motion";

import styles from "./styles.module.css";
import CustomButton from "src/components/customButton/CustomButton";
import HeroImg from "src/assets/images/home/hero.webp";

import { isRTL } from "src/utils/global";
import { scrollToSection } from "src/utils/scroll";

const HeroSection: React.FC = () => {
    const { t, i18n } = useTranslation("home");

    // Animation variants with typing
    const fadeUp: Variants = {
        hidden: { opacity: 0, y: 40 },
        visible: (i: number) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.2,
                duration: 0.8,
                ease: "easeOut",
            },
        }),
    };

    return (
        <section
            className={`${styles.hero__con} ${isRTL() ? styles.rtl : ""}`}
            style={{ ["--hero-image" as any]: `url(${HeroImg})` }}
        >
            <div className={styles.content}>
                {/* Animated Title */}
                <motion.h2
                    variants={fadeUp}
                    initial="hidden"
                    animate="visible"
                    custom={0}
                >
                    {t("hero.company_name")} {t("hero.tagline")}
                </motion.h2>

                {/* Animated Description */}
                <motion.p
                    variants={fadeUp}
                    initial="hidden"
                    animate="visible"
                    custom={1}
                >
                    {t("hero.description")}
                </motion.p>

                {/* Animated Button */}
                <motion.div
                    variants={fadeUp}
                    initial="hidden"
                    animate="visible"
                    custom={2}
                >
                    <CustomButton
                        text={
                            <>
                                {t("hero.explore")}
                                {i18n.language.includes("ar") ? (
                                    <FaArrowLeft color="#fff" />
                                ) : (
                                    <FaArrowRight color="#fff" />
                                )}
                            </>
                        }
                        theme="primary"
                      
                        onClick={() => scrollToSection("aboutUs")}
                    />
                </motion.div>
            </div>
        </section>
    );
};

export default HeroSection;
